import { render, staticRenderFns } from "./IngresoDetalle.vue?vue&type=template&id=1bf25a0a&"
import script from "./IngresoDetalle.vue?vue&type=script&lang=js&"
export * from "./IngresoDetalle.vue?vue&type=script&lang=js&"
import style0 from "./IngresoDetalle.vue?vue&type=style&index=0&id=1bf25a0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports